import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDriftDates, getIsPeriodIntraday } from "modules/security-profile/selectors/dates"
import { getFilteredData, getCategoryItemsSubset, getRiskAttribution } from "./selectors/data"
import { getOptions } from "./selectors/options"
import { getDisplayType } from "./selectors/items"
import { computePositionSet, getSingleDateBase } from "modules/security-profile/helpers/security"
import { getFirstRiskDate, getMaxFactors } from "./selectors/risk"
import { getDetails } from "./selectors/details"

const riskSubQuery = `
              total
              attribution {
                summary {
                  factors
                  specific
                }
                factors {
                  id
                  category
                  name
                  value
                }
              }`

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    driftDates: getDriftDates(state),
    isPeriodIntraday: getIsPeriodIntraday(state, props),
  }),
  data: [{
    resource: "securityRiskHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, driftDates, startDate, endDate, isPeriodIntraday }) => {
      if (isPeriodIntraday) {
        base = getSingleDateBase(base, endDate)

        return {
          id: `securityRiskHistory-intraday-${modelId}${ticker}${mic}${endDate}${JSON.stringify(base)}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $endDate: Date!) {
          model (id: $modelId) {
            intradaySimulation(positionSet: $positionSet, base: $base, on: $endDate) {
              risk {
                date: timestamp
                ${riskSubQuery}
              }
            }
          }
        }`,
          variables: {
            modelId,
            positionSet: {
              dates: [{
                date: endDate,
                ...computePositionSet(assetClass, ticker, mic, modelProviderId),
              }],
            },
            base,
            endDate,
          },
        }
      }

      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      base = getSingleDateBase(base, from)

      return {
        id: `securityRiskHistory-${modelId}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
              risk {
                date,${riskSubQuery}
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    displayType: getDisplayType(state),
    firstDate: getFirstRiskDate(state),
    options: getOptions(state),
    details: getDetails(state),
    riskAttribution: getRiskAttribution(state, props),
    maxFactors: getMaxFactors(state, props),
    ...state.modules.securityProfileRisk,
  }),
  actions: {
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
    ...Creators,
  },
})
